/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import debounce from 'react-utils/debounce';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { LinkTypes } from '../../constants/link';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.links.${suffix}`;
export default class PageLinkField extends Component {
  constructor(props) {
    super(props);
    this.fetchPublishedContent = debounce(this.fetchPublishedContent.bind(this), 200);
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  fetchPublishedContent(input, callback, pagination = {
    offset: 0
  }) {
    const {
      fetchPages
    } = this.props;
    fetchPages({
      term: input,
      offset: pagination.offset
    }).then(data => {
      if (!this.mounted) {
        return;
      }
      const parsedData = data.objects.map(asset => {
        return {
          text: asset.name,
          value: asset.url,
          help: asset.url
        };
      });
      const fetchedPages = !data.offset ? parsedData : this.state.fetchedPages.concat(parsedData);
      this.setState({
        fetchedPages
      });
      callback(null, {
        options: fetchedPages,
        pagination: {
          hasMore: data.offset + data.limit < data.totalCount,
          length: data.totalCount,
          offset: pagination.offset + 10
        }
      });
    }, () => {
      if (!this.mounted) {
        return;
      }
      this.setState({
        fetchError: true
      });
      callback(null);
    });
  }
  render() {
    const {
      url,
      onChange,
      dropdownClassName
    } = this.props;
    return /*#__PURE__*/_jsx(UIFormControl, {
      label: I18n.text(i18nKey(`linkTypes.${LinkTypes.PAGE}.label`)),
      className: "m-top-0",
      children: /*#__PURE__*/_jsx(UISelect, {
        dropdownClassName: dropdownClassName,
        searchable: true,
        cache: false,
        loadOptions: this.fetchPublishedContent,
        filterOptions: false,
        value: url,
        onSelectedOptionChange: ({
          target: {
            value: data
          }
        }) => {
          onChange({
            url: data.value,
            pageName: data.text
          });
        },
        placeholder: I18n.text(i18nKey(`linkTypes.${LinkTypes.PAGE}.placeholder`))
      })
    });
  }
}
PageLinkField.propTypes = {
  url: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  fetchPages: PropTypes.func.isRequired,
  dropdownClassName: PropTypes.string
};